import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import {
  OutlinedInput,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Typography,
  Checkbox,
  FormControlLabel,
  Button,
  TextField,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const locationOptions = ["Clinic", "Online", "Home Visit"];

function getStyles(location, allowedLocations, theme) {
  return {
    fontWeight: allowedLocations.includes(location)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

function ServiceEdit({ serviceDetails, onSave, service }) {
  //const [editedData, setEditedData] = useState(serviceData);
  const theme = useTheme();
  const [isEditing, setIsEditing] = useState(false);
  const [serviceData, setServiceData] = useState(serviceDetails);
     

  useEffect(() => {
    //setEditedData(serviceData); // Initialize the form with the existing data
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setServiceData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSave = () => {
    // Call an API or a function to save the updated service data
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setServiceData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleLocationChange = (event) => {
    setServiceData((prev) => ({
      ...prev,
      allowedLocations: event.target.value,
    }));
  };

 

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSave) {
      onSave(serviceDetails);
    }
  };


  return (
    <Grid2 size={4} container direction="column" spacing={1} sx={{ padding: 2 }}>
      <Grid2 container size={12}>
          <Grid2 item>
            <Button variant="contained" color="secondary" onClick={() => setIsEditing(!isEditing)}>
              {isEditing ? "Cancel" : "Edit"}
            </Button>
          </Grid2>
          {isEditing && (
            <Grid2 item>
              <Button variant="contained" color="secondary" onClick={handleSave}>
                Save
              </Button>
            </Grid2>
          )}
        </Grid2>

      {/* Input Fields */}
      <TextField
        margin="dense"
        size="small"
        variant="outlined"
        label="Source Code"
        name="sourceCode"
        fullWidth
        value={serviceData?.code}
        onChange={handleChange}
      />

      <TextField
        label="Service Name"
        name="name"
        size="small"
        variant="outlined"
        fullWidth
        value={serviceData?.name}
        onChange={handleChange}
      />

      {/* Fees & Edit Fee - Compact Alignment */}
      <Grid2 container alignItems="center" spacing={1}>
        <Grid2 item flexGrow={1}>
          <TextField
            fullWidth
            variant="outlined"
            label="Fees (INR)"
            name="fees"
            size="small"
            type="number"
            value={serviceData?.fees}
            onChange={handleChange}
          />
        </Grid2>
        <FormControlLabel
          control={
            <Checkbox
              checked={serviceData?.allowFeesEdit}
              onChange={handleCheckboxChange}
              name="EditFee"
            />
          }
          label="Allow Fees Editing"
          sx={{ ml: 1 }}
        />
      </Grid2>

      <TextField
        label="Duration (Minutes)"
        variant="outlined"
        fullWidth
        type="number"
        size="small"
        name="duration"
        value={serviceData?.durationInMins}
        onChange={handleChange}
      />

      <TextField
      id="outlined-multiline-static"
      margin="dense"
        label="Description"
        name="description"
        size="small"
        variant="outlined"
        multiline
        rows={3}
        fullWidth
        value={serviceData?.description}
        onChange={handleChange}
      />

      {/* Allowed Locations Dropdown */}
      <FormControl fullWidth>
        <InputLabel id="allowed-locations-label">Allowed  Locations</InputLabel>
        <Select
          labelId="allowed-locations-label"
          id="allowed-locations"
          multiple
          value={serviceData.allowedLocations}
          onChange={handleLocationChange}
          input={<OutlinedInput label="Allowed Locations" />}
          MenuProps={MenuProps}
        >
          {locationOptions.map((location) => (
            <MenuItem
              key={location}
              value={location}
              style={getStyles(location, serviceData?.allowedLocations, theme)}
            >
              {location}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Checkboxes (Compact Alignment) */}
      <FormControlLabel
        control={
          <Checkbox
            checked={serviceData?.isActive}
            onChange={handleCheckboxChange}
            name="isActive"
          />
        }
        label="Is Active"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={serviceData?.canBePrimary}
            onChange={handleCheckboxChange}
            name="canBePrimary"
          />
        }
        label="Can Be Primary"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={serviceData?.allowedBookingType}
            onChange={handleCheckboxChange}
            name="allowedBookingType"
          />
        }
        label="Allowed Booking Type"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={serviceData?.schedulingByPatient}
            onChange={handleCheckboxChange}
            name="schedulingByPatient"
          />
        }
        label="Scheduling by Patient"
      />
    </Grid2>
  );
}

export default ServiceEdit;